import './scheduling-project.module';
import './scheduling-project.config';
import './$schedulingProject.factory';

import './services';
import './components';
